import { defineMessages } from 'react-intl';

export default defineMessages({
    mortgageValidationMsg: {
        id: 'tfpa.policyChange.contacts.policyroles.Mortgage Position cannot be skipped. Please enter mortgagees in order of first, second, and third',
        defaultMessage: 'Mortgage Position cannot be skipped. Please enter mortgagees in order of first, second, and third.',
    },
    mortgageValidationTitle: {
        id: 'tfpa.policyChange.contacts.policyroles.Invalid Mortgage Positions',
        defaultMessage: 'Invalid Mortgage Positions',
    },
    yesModal: {
        id: 'tfpa.policyChange.translation.additionalInformation.Yes',
        defaultMessage: 'Yes'
    },
    noModal: {
        id: 'tfpa.policyChange.translation.additionalInformation.No',
        defaultMessage: 'No'
    },
    saveFailedMsg: {
        id: 'tfpa.policyChange.contacts.policyroles.Save failed',
        defaultMessage: 'Save failed, please try again',
    },
    saveFailedTitle: {
        id: 'tfpa.policyChange.contacts.policyroles.Cannot Modify Contact',
        defaultMessage: 'Can\'t Modify Contact',
    },
    cancel: {
        id: 'tfpa.policyChange.translation.additionalInformation.Cancel',
        defaultMessage: 'Cancel'
    },
    removeAdditionalInterest: {
        id: 'tfpa.policyChange.translation.additionalInformation.Remove Additional Interest',
        defaultMessage: 'Remove Additional Interest?'
    },
    removeAddlInterestMessage: {
        id: 'tfpa.policyChange.translation.additionalInformation.Are you sure you want to remove this contact?',
        defaultMessage: 'Are you sure you want to remove this item?'
    },
    contractofSale: {
        id: 'tfpa.policyChange.translation.additionalInformation.Contract of Sale',
        defaultMessage: 'Contract of Sale'
    },
    mortgagee: {
        id: 'tfpa.policyChange.translation.additionalInformation.Mortgagee',
        defaultMessage: 'Mortgagee'
    },
    alternatePayor: { // DE18024
        id: 'tfpa.policyChange.additionalInformation.Alternate Payor',
        defaultMessage: 'Alternate Payor'
    },
    mortgageeEscrow: {
        id: 'tfpa.policyChange.additionalInformation.mortgageeEscrow',
        defaultMessage: 'Mortgagee Escrow'
    },
    lossPayee: {
        id: 'tfpa.policyChange.translation.additionalInformation.Loss Payee',
        defaultMessage: 'Loss Payee'
    },
    premiumFinance: {
        id: 'tfpa.policyChange.translation.additionalInformation.Premium Finance',
        defaultMessage: 'Premium Finance'
    },
    firstMortgagee: {
        id: 'tfpa.policyChange.translation.additionalInformation.First Mortgage',
        defaultMessage: 'First Mortgage'
    },
    secondMortgagee: {
        id: 'tfpa.policyChange.translation.additionalInformation.Second Mortgage',
        defaultMessage: 'Second Mortgage'
    },
    thirdMortgagee: {
        id: 'tfpa.policyChange.translation.additionalInformation.Third Mortgage',
        defaultMessage: 'Third Mortgage'
    },
    close: {
        id: 'tfpa.policyChange.residential.additionalInsured.Close',
        defaultMessage: 'Close'
    },
    invalidMortgagePosition: {
        id: 'tfpa.policyChange.residential.additionalInsured.invalidMortgagePosition',
        defaultMessage: 'Mortgage Position cannot be skipped. Please enter mortgagees in order of first, second, and third.'
    }
    
});
